import { createSharedComposable } from '@vueuse/core'

const _useDashboard = () => {
  const router = useRouter()

  defineShortcuts({
    'g-h': () => router.push('/'),
    'g-m': () => router.push('/manage'),
    'g-c': () => router.push('/chat'),
    'g-s': () => router.push('/system'),
  })
}

export const useDashboard = createSharedComposable(_useDashboard)
